import { create, test, enforce } from 'vest';

const validate = create('ProjectForms', (data) => {
    test('name', 'Name is required.', () => {
        enforce(data.name)
            .isNotEmpty();
    });
});

export default validate;
